<template>
  <div>
    <h1>Products</h1>
    <DxDataGrid 
      ref="dataGrid"
      :dataSource="products" 
      :showBorders="true" 
      class="custom-grid"
      :columnAutoWidth="true"
      :rowAlternationEnabled="true"
      :selection="{ mode: 'multiple' }"
      height="100%"
      :keyExpr="'id'"
      @rowClick="onRowClick"
    >
      <DxColumnFixing :enabled="true" />
      <DxColumnChooser :enabled="true" />
      <DxHeaderFilter :visible="true" />
      <dx-scrolling :mode="'virtual'" />
      <dx-load-panel :show-pane="false" />
      <dx-search-panel
        :visible="true"
        placeholder="Product Search"
      />
      <dx-export
        :enabled="true"
        :allow-export-selected-data="true"
        :formats="['xlsx', 'pdf']"
      />
      <dx-selection
        select-all-mode="allPages"
        show-check-boxes-mode="always"
        mode="multiple"
      />

      <dx-grid-toolbar>
        <!--
        <dx-grid-toolbar-item location="before">
          <div class="grid-header">
            Categories
          </div>
        </dx-grid-toolbar-item>
        -->
        <dx-grid-toolbar-item
          location="after"
          locate-in-menu="auto"
        >
          <div>
            <dx-button
              text="Add Category"
              icon="plus"
              type="default"
              styling-mode="contained"
              @click="openAddCategoryPopup"
            />
          </div>
        </dx-grid-toolbar-item>
        <dx-grid-toolbar-item
          location="after"
          locate-in-menu="auto"
        >
          <div>
            <dx-button
              text="Add Product"
              icon="plus"
              type="default"
              styling-mode="contained"
              @click="openAddProductPopup"
            />
          </div>
        </dx-grid-toolbar-item>

        <dx-grid-toolbar-item
          location="after"
          locate-in-menu="auto"
          show-text="inMenu"
          widget="dxButton"
          :options="{ icon: 'refresh', onClick: refreshData}"
        />

        <dx-grid-toolbar-item
          location="after"
          locate-in-menu="auto"
        >
          <div>
            <div class="separator" />
          </div>
        </dx-grid-toolbar-item>

        <dx-grid-toolbar-item name="exportButton" />

        <dx-grid-toolbar-item
          location="after"
          locate-in-menu="auto"
        >
          <div>
            <div class="separator" />
          </div>
        </dx-grid-toolbar-item>

        <dx-grid-toolbar-item
          name="columnChooserButton"
          locate-in-menu="auto"
        />

        <dx-grid-toolbar-item
          name="searchPanel"
          locate-in-menu="auto"
        />
      </dx-grid-toolbar>
      <DxColumn dataField="id" caption="Id" :fixed="true" fixed-position="sticky" width="80px"/>
      <DxColumn dataField="name" caption="Name" />
      <DxColumn dataField="description" caption="Description" />
      <DxColumn dataField="price" caption="Price" />
      <DxColumn dataField="category_name" caption="Category" />
    </DxDataGrid>
  </div>
  <form-popup
    title="New Product"
    v-model:visible="isAddProductPopupOpened"
    @save="refreshData"
  >
  </form-popup>
  <form-popup-category
    title="New Category"
    v-model:visible="isAddCategoryPopupOpened"
    @save="refreshData"
  >
  </form-popup-category>
  <ProductPanel
      :isPanelOpened="isPanelOpened"
      :product="selectedProduct"
      @closePanel="closePanel"
      @saveProduct="saveProduct"
      @deleteProduct="deleteProduct"
    />
</template>

<script>
import { 
        DxDataGrid, 
        DxColumn, 
        DxSearchPanel, 
        DxColumnChooser, 
        DxColumnFixing, 
        DxExport, 
        DxHeaderFilter,
        DxScrolling,
        DxToolbar as DxGridToolbar,
        DxItem as DxGridToolbarItem,
        DxLoadPanel,
        DxSelection
        } from 'devextreme-vue/data-grid';
import { DxButton } from 'devextreme-vue/button';
import FormPopup from './utils/form-popup.vue';
import FormPopupCategory from './utils/category-popup.vue';
import ProductPanel from './utils/ProductPanel.vue';

export default {
  name: 'ShowProducts',
  components: {
    DxDataGrid,
    DxColumn,
    DxSearchPanel,
    DxColumnChooser,
    DxColumnFixing,
    DxExport,
    DxHeaderFilter,
    DxScrolling,
    DxGridToolbar,
    DxGridToolbarItem,
    DxButton,
    DxLoadPanel,
    DxSelection,
    FormPopup,
    FormPopupCategory,
    ProductPanel
  },
  data() {
    return {
      products: [],
      isAddProductPopupOpened: false,
      isAddCategoryPopupOpened: false,
      isPanelOpened: false,
      selectedProduct: null     
    };
  },
  async created() {
    this.refreshData();
  },
  methods: {
    async refreshData() {
      try {
        const response = await fetch(`${process.env.VUE_APP_API_URL}/product/read.php`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        console.log('response:', response);
        const data = await response.json();
        this.products = data.records;
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    },

    openAddProductPopup() {
      // console.log('AddProduct button clicked!');
      this.isAddProductPopupOpened = true;
    },
    openAddCategoryPopup() {
      // console.log('AddProduct button clicked!');
      this.isAddCategoryPopupOpened = true;
    },
    onRowClick(e) {
      this.selectedProduct = { ...e.data };
      this.isPanelOpened = true;
    },
    closePanel() {
      this.isPanelOpened = false;
    },
    saveProduct(product) {
      fetch(`${process.env.VUE_APP_API_URL}/product/update.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(product)
      })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.refreshData(); // Refresh the product list
          this.closePanel();
        } else {
          console.error('Failed to save product:', data.message);
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
    },
    deleteProduct(productId) {
      fetch(`${process.env.VUE_APP_API_URL}/product/delete.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: productId })
      })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          this.refreshData(); // Refresh the product list
          this.closePanel();
        } else {
          console.error('Failed to delete product:', data.message);
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }
  }

};


</script>

<style scoped>
h1 {
  color: #42b983;
}

.custom-grid {
  width: 70%;
  margin: 0 auto; /* Center the table horizontally */
}

.custom-grid .dx-datagrid {
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-grid .dx-datagrid-headers {
  background-color: #f5f5f5;
  font-weight: bold;
}

/*
.custom-grid .dx-datagrid-search-panel {
  display: flex;
  justify-content: flex-end;
}

.custom-grid .dx-datagrid-search-panel .dx-texteditor-container {
  width: 50%;
}
*/
.custom-grid .dx-datagrid-rowsview .dx-row {
  border-bottom: 1px solid #e0e0e0;
}

.custom-grid .dx-datagrid-rowsview .dx-row:hover {
  background-color: #f0f0f0;
}

.custom-grid .dx-datagrid-rowsview .dx-row .dx-cell {
  padding: 10px;
}
</style>
